import { Controller } from '@hotwired/stimulus'
import { trackCtaClick, trackFormulaLinkClick } from '../lib/playground_analytics.js'

export default class extends Controller {
  static values = {
    pageType: { type: String, default: 'index' },
    hubSlug: { type: String, default: '' },
  }

  trackCta(event) {
    const link = event.currentTarget

    trackCtaClick({
      pageType: this.pageTypeValue,
      hubSlug: this.hubSlugValue,
      ctaLabel: link.dataset.playgroundCtaLabel || link.textContent.trim(),
      ctaDestination: link.getAttribute('href'),
    })
  }

  trackFormulaLink(event) {
    const link = event.currentTarget

    trackFormulaLinkClick({
      pageType: this.pageTypeValue,
      hubSlug: this.hubSlugValue,
      formulaSlug: link.dataset.playgroundFormulaSlug,
      linkLabel: link.dataset.playgroundLinkLabel || link.textContent.trim(),
    })
  }
}
